/**
 * API helper functions for custom cultural element chat feature
 */

// Use the same pattern as other API calls in the codebase
// The Django main urls.py includes kumu urls at /api/ directly
const API_BASE_URL = '/api';

/**
 * Get auth token from localStorage
 */
const getAuthToken = () => {
  return localStorage.getItem('authToken');
};

/**
 * Send a chat message and get AI response for custom cultural element creation
 * @param {string} lessonPlanId - ID of the lesson plan
 * @param {string} message - User's message
 * @param {Array} chatHistory - Previous messages in the chat
 * @param {string} grade - Grade level
 * @param {string} standard - Educational standard
 * @param {string} language - Language (e.g., 'en', 'haw')
 * @param {string} moku - Selected moku (optional)
 * @param {string} island - Selected island (optional)
 * @returns {Promise<Object>} Response object with AI message and cultural element data
 */
export const sendCulturalElementChatMessage = async (
  lessonPlanId, 
  message, 
  chatHistory = [],
  grade = null,
  standard = null,
  language = null,
  moku = null,
  island = null,
  existingElements = null
) => {
  const token = getAuthToken();
  
  if (!token) {
    throw new Error('No authentication token found');
  }

  const response = await fetch(`${API_BASE_URL}/custom-cultural-element-chat/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    },
    body: JSON.stringify({
      lesson_plan_id: lessonPlanId,
      message: message,
      chat_history: chatHistory,
      grade: grade,
      standard: standard,
      language: language,
      moku: moku,
      island: island,
      existing_elements: existingElements
    })
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
  }

  return await response.json();
};
